import { Component } from '@angular/core';
import { LoginService } from '../../../services/login-service';
import { HttpService } from '../../utility/http-service';

interface Manual {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  icon: string;
  fileName: string;
  assetPath: string;
  fracXOnly: boolean;
  badge?: string;
}

@Component({
  selector: 'app-user-manuals',
  templateUrl: './user-manuals.component.html',
  styleUrl: './user-manuals.component.css',
  standalone: false,
})
export class UserManualsComponent {
  viewingManual: Manual | null = null;

  manuals: Manual[] = [
    {
      id: 'fracx-user-guide',
      title: 'FracX User Guide',
      subtitle: 'Complete Reference',
      description:
        'The comprehensive guide covering all FracX features — job scheduling, well management, map views, data uploads, and reporting workflows.',
      icon: 'book',
      fileName: 'FracX-User-Guide.pdf',
      assetPath: 'assets/manuals/FracX-User-Guide.pdf',
      fracXOnly: false,
    },
    {
      id: 'wellchron-client-guide',
      title: 'Sign-In and API Guide',
      subtitle: 'Enverus Sign-In & REST API',
      description:
        'How to sign in with Enverus authentication, create an API token, and call the WellChron REST API — with every GET and POST endpoint, its parameters, and examples.',
      icon: 'code',
      fileName: 'WellChron-Client-Guide.pdf',
      assetPath: 'assets/manuals/WellChron-Client-Guide.pdf',
      fracXOnly: false,
      badge: 'API',
    },
  ];

  constructor(
    public loginService: LoginService,
    private http: HttpService
  ) {}

  get visibleManuals(): Manual[] {
    return this.manuals.filter(
      (m) => !m.fracXOnly || this.loginService.user?.enableFracXAutomation
    );
  }

  openViewer(manual: Manual): void {
    this.viewingManual = manual;
  }

  closeViewer(): void {
    this.viewingManual = null;
  }

  downloadManual(manual: Manual, event: Event): void {
    event.stopPropagation();
    const a = document.createElement('a');
    a.href = manual.assetPath;
    a.download = manual.fileName;
    a.click();
  }
}
